/**
 * Single, controlled production origin for the site.
 *
 * All canonical URLs, og:url values and share URLs generated by the
 * SEO component (and by any page that builds its own JSON-LD) must
 * originate from SITE_ORIGIN — never from window.location.origin.
 *
 * The only hostname that is treated as production is exactly
 * "drtaniasingh.com" (non-www). Every other runtime host — Emergent
 * previews, localhost, 127.0.0.1, temporary Hostinger domains, raw
 * IP access, staging subdomains, and even www.drtaniasingh.com if it
 * ever serves content before the permanent redirect — must render
 * noindex,nofollow.
 */

export const SITE_ORIGIN = "https://drtaniasingh.com";
export const PRODUCTION_HOSTNAME = "drtaniasingh.com";

/**
 * True only when the current runtime origin is exactly the approved
 * production origin — HTTPS protocol AND the exact non-www hostname.
 *
 * Any other combination is treated as non-production, including:
 *   - http://drtaniasingh.com (same hostname, wrong protocol)
 *   - https://www.drtaniasingh.com (wrong hostname, even over HTTPS)
 *   - Emergent previews, localhost, 127.0.0.1, IPs, staging.*, etc.
 */
export function isProductionOrigin() {
  if (typeof window === "undefined") return false;
  return (
    window.location.protocol === "https:" &&
    window.location.hostname === PRODUCTION_HOSTNAME
  );
}

/**
 * Normalise a pathname to the canonical form:
 *   - always starts with "/"
 *   - strips query strings and hash fragments
 *   - collapses accidental duplicate slashes
 *   - removes a trailing slash for anything other than the root
 */
function normalisePath(pathname) {
  let p = (pathname || "/").split("?")[0].split("#")[0];
  if (!p.startsWith("/")) p = "/" + p;
  p = p.replace(/\/{2,}/g, "/");
  if (p.length > 1 && p.endsWith("/")) p = p.slice(0, -1);
  return p;
}

/**
 * Build a canonical URL from the controlled production origin and a
 * normalised pathname. Query strings and fragments are intentionally
 * excluded — pages such as /contact?type=appointment canonicalise to
 * https://drtaniasingh.com/contact.
 */
export function buildCanonical(pathname) {
  return SITE_ORIGIN + normalisePath(pathname);
}
